module.exports = __webpack_public_path__ + "static/media/biponon-pink.3c3bd2d4.svg";